



























































import { Vue, Component, Watch } from "vue-property-decorator";
import UserTable from "@/components/user/UserTable.vue";
import userService from "@/services/userService";
import { getModule } from "vuex-module-decorators";
import SnackbarModule from "@/store/snackbarModule";
import UserModule from "@/store/userModule.ts";
import CalendarModule from "@/store/calendarModule.ts";
import UserModel from "@/models/user/userModel";
import UserSettingsUpsertModel from "@/models/user/userSettingsUpsertModel";
import ValidationService from "@/services/validationService";
import { DataTableHeader } from "vuetify";

const snackbarModule = getModule(SnackbarModule);
const userModule = getModule(UserModule);
const calendarModule = getModule(CalendarModule);

@Component({ components: { UserTable } })
export default class Users extends Vue {
  private items: Array<UserModel> = [];
  private users: Array<UserModel> = [];
  private dialogEdit = "";
  private order = 0;
  private validationService: ValidationService = new ValidationService();
  private dialog = false;
  private dialogLoading = false;
  private loading = false;
  private headers: Array<DataTableHeader<UserModel>> = [
    {
      text: "Name",
      value: "fullname"
    },
    {
      text: "Order",
      value: "order"
    },
    {
      text: "",
      value: "delete",
      sortable: false
    }
  ];

  get calendarId(): string {
    return calendarModule.getCalendarId;
  }

  private async created(): Promise<void> {
    await this.getUsers();
    await this.getItems();
  }

  private async getItems() {
    try {
      this.loading = true;
      this.items = await userService.getAllUserSettings(
        calendarModule.getCalendarId
      );
    } catch {
      snackbarModule.snackError("Failed to fetch user settings");
    } finally {
      this.loading = false;
    }
  }

  private async getUsers() {
    try {
      this.loading = true;
      this.users = await userService.getAllUsersByClientAsync(
        userModule.userId
      );
    } catch {
      snackbarModule.snackError("Failed to fetch users");
    } finally {
      this.loading = false;
    }
  }

  private async removeUser(item: UserModel) {
    try {
      await userService.deleteUserSettings(item.userSettingsId);
      snackbarModule.snackSuccess("User removed");
      this.dialog = false;
    } catch {
      snackbarModule.snackError("User removal failed");
    }
    await this.getItems();
  }

  private async onBeginCreateItem() {
    this.dialog = true;
    this.dialogEdit = "";
  }

  private async onCancel() {
    (this.$refs.form as Vue & { reset: () => void }).reset();
    this.dialog = false;
    this.dialogEdit = "";
  }

  private async onCreateItem() {
    if (!this.validateForm()) {
      return;
    }

    try {
      this.dialogLoading = true;
      await userService.createUserSettings(
        new UserSettingsUpsertModel({
          calendarId: calendarModule.getCalendarId,
          calendarUserId: this.dialogEdit,
          order: this.order
        })
      );
      snackbarModule.snackSuccess("User added");
      this.dialog = false;
    } catch (e) {
      snackbarModule.snackError(e.response.data);
    } finally {
      this.dialogLoading = false;
    }
    await this.getItems();
  }

  private async onEditItem(item: UserModel) {
    try {
      await userService.updateUserSettings(
        item.userSettingsId,
        new UserSettingsUpsertModel({
          calendarId: calendarModule.getCalendarId,
          calendarUserId: item.userId,
          order: item.order
        })
      );
      snackbarModule.snackSuccess("User updated");
      this.dialog = false;
    } catch (e) {
      snackbarModule.snackError(e.response.data);
    } finally {
      this.dialogLoading = false;
    }
    await this.getItems();
  }

  private validateForm(): boolean {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }

  @Watch("calendarId")
  private async onCalendarChanged() {
    await this.getItems();
  }
}
